import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_14 = { class: "col-lg-8 fv-row" }
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "row mb-6" }
const _hoisted_18 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_19 = { class: "col-lg-8 fv-row" }
const _hoisted_20 = { class: "fv-plugins-message-container" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_23 = {
  href: "/",
  type: "button",
  class: "btn btn-white btn-active-light-primary me-2"
}
const _hoisted_24 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_25 = { class: "indicator-label" }
const _hoisted_26 = { class: "indicator-progress" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('ChangeYourPassword')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_Form, {
        class: "form",
        onSubmit: _ctx.onSubmitCreate,
        "validation-schema": _ctx.validationSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.translate('currentPassword')), 1),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_Field, {
                  type: "password",
                  name: "currentPassword",
                  autocomplete: "off",
                  class: "form-control form-control-lg form-control-solid",
                  placeholder: _ctx.translate('currentPassword')
                }, null, 8, ["placeholder"]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_ErrorMessage, { name: "currentPassword" })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.translate('newPassword')), 1),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_Field, {
                  type: "password",
                  name: "newPassword",
                  autocomplete: "off",
                  class: "form-control form-control-lg form-control-solid",
                  placeholder: _ctx.translate('password')
                }, null, 8, ["placeholder"]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_ErrorMessage, { name: "newPassword" })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.translate('confirmPassword')), 1),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_Field, {
                  type: "password",
                  name: "confirmPassword",
                  autocomplete: "off",
                  class: "form-control form-control-lg form-control-solid",
                  placeholder: _ctx.translate('confirmPassword')
                }, null, 8, ["placeholder"]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_ErrorMessage, { name: "confirmPassword" })
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("a", _hoisted_23, _toDisplayString(_ctx.translate('discard')), 1),
            _createElementVNode("button", _hoisted_24, [
              _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.translate('saveChanges')), 1),
              _createElementVNode("span", _hoisted_26, [
                _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                _hoisted_27
              ])
            ], 512)
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}